<script>
export default {
  name: "DateComponent",
  props: {
    date: {
      type: Object,
      required: true
    },
    searchSubmitHandler: {
      type: Function,
      required: true
    },
    normalizeDateFormatHandler: {
      type: Function,
      required: true
    }
  }
}
</script>

<template>
  <div class="row">
    <div class="col-sm-6">
      <div class="form-group">
        <label>
          Дата оценки
          <span class="prompt-text">(дата смерти наследодателя)</span>
        </label>
        <VueDatePicker
          v-model="date.value"
          model-type="timestamp"
          locale="ru"
          :enable-time-picker="false"
          auto-apply
          format="dd.MM.yyyy"
          @closed="searchSubmitHandler()"
          text-input
          utc="preserve"
          @keyup="normalizeDateFormatHandler"
          placeholder="__.__.____"
        />
        <p class="error" v-if="date.hasError">{{ date.errorText }}</p>
      </div>
    </div>
  </div>
</template>

<style scoped>

label .prompt-text {
  font-size: 12px;
  font-weight: normal;
  color: #606060;
}

</style>
